export enum UserTokenType {
  bearer = 'Bearer'
}
